import { RelationshipType, TableRelationshipFilterDirection } from '../relationships.types'

type DirectionOption = { label: string; value: TableRelationshipFilterDirection }

export const DIRECTION_TYPE_OPTIONS: DirectionOption[] = [
  {
    label: 'Single',
    value: TableRelationshipFilterDirection.SINGLE,
  },
  {
    label: 'Both',
    value: TableRelationshipFilterDirection.CROSS,
  },
]

type RROption = { label: string; value: RelationshipType }

export const RELATIONSHIP_TYPE_OPTIONS: RROption[] = [
  {
    label: 'One to One',
    value: RelationshipType.ONE_TO_ONE,
  },
  {
    label: 'One to Many',
    value: RelationshipType.ONE_TO_MANY,
  },
  {
    label: 'Many to Many',
    value: RelationshipType.MANY_TO_MANY,
  },
  {
    label: 'Many to One',
    value: RelationshipType.MANY_TO_ONE,
  },
]
